import type { Sector } from "~/modules/sector/models/Sector.interface";

/**
 * Return a flatten list of sectors from a tree of sectors
 * @param sector The root sector
 * @param result
 */
export function getFlattenSectors(
  sector: Sector,
  result: Sector[] = [],
): Sector[] {
  result.push(sector);
  if (sector.children?.length > 0) {
    for (const child of sector.children) {
      getFlattenSectors(child, result);
    }
  }
  return result;
}
